import { render } from "./mallList.vue?vue&type=template&id=5809edd0&scoped=true&ts=true"
import script from "./mallList.vue?vue&type=script&lang=ts"
export * from "./mallList.vue?vue&type=script&lang=ts"

import "./mallList.vue?vue&type=style&index=0&id=5809edd0&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5809edd0"]])

export default __exports__